import React, { useState, useEffect } from "react";
import DashboardStatusCard from "../officerDashboard/dashboardStatusCard";
import axios from "axios";
import { AUTH_URL } from "../../utils/constants";
import { ThreeDotsLoader } from "../commonComponent/loader";
import bgOfficer from "../../assets/images/bg_officer.png";
import listIcon from "../../assets/images/list.png";
import Swal from "sweetalert2";
import DashboardStatesUser from "../dashboard/DashboardUser";
import AdminUser from "./AdminUser";
import { useAuth } from "../../utils/AuthContext";

const AdminDashboard = () => {
  const [data, setData] = useState([]);
  const [overdueData, setOverdueData] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [showCommentArea, setShowCommentArea] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [comment, setComment] = useState(""); // New state to store comment
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [queryUpdate, setQueryUpdate] = useState(true);
  const { user } = useAuth();

  const handleViewClick = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };
  const handleLikeClick = (e) => {
    e.preventDefault();
    setIsLiked(true);
    setShowCommentArea(false); // Hide comment area after liking
  };

  const handleDislikeClick = (e) => {
    e.preventDefault();
    setIsLiked(false);
    setShowCommentArea(true); // Show comment area after disliking
  };

  const handleSave1 = async () => {
    setSaveLoading(true);
    try {
      const feedbackData = {
        grievance_id: selectedRow.id, // Assuming you have selectedRow.id for grievance ID
        feedbackrating: isLiked ? 1 : 0, // 1 for like, 0 for dislike
        feedbacktext: comment, // The comment entered by the user
      };

      const res = await axios(`${AUTH_URL}/api/feedback`, feedbackData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status === 200) {
        console.log("Feedback saved successfully");
        // Optionally, reset the states after saving
        setIsLiked(false);
        setComment("");
        setShowCommentArea(false);
      }
    } catch (error) {
      console.error("Error saving feedback:", error);
    } finally {
      setSaveLoading(false);
    }
  };

  // useEffect(() => {
  //   console.log("all query dashboard : 75");
  //   const getUserQueriesCall = async () => {
  //     setLoading(true);
  //     try {
  //       let res = await axios.get(`${AUTH_URL}api/allquery`, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       if (res.data) {
  //         const apiPayload = Array.isArray(res.data) ? res.data : res.data.queries || [];
  //         const reversedData = Array.isArray(apiPayload) ? [...apiPayload].reverse() : [];

  //         const normalizeStatus = (status) => {
  //           const s = (status || 'pending').toLowerCase();
  //           if (s === 'pending') return 'Pending';
  //           if (s === 'resolved' || s === 'closed') return 'Resolved';
  //           if (s === 'rejected') return 'Rejected';
  //           if (s === 'responded') return 'Responded';
  //           return 'Other';
  //         };

  //         const buildStatusSummary = (items) => {
  //           // Check if items is the new format: array of {user_id, status, percentage}
  //           if (Array.isArray(items) && items.length > 0 && items[0].hasOwnProperty('percentage') && items[0].hasOwnProperty('status')) {
  //             // New format: aggregate percentages by status
  //             const summaryMap = {};
  //             items.forEach((item) => {
  //               const status = normalizeStatus(item.status);
  //               if (!summaryMap[status]) {
  //                 summaryMap[status] = {
  //                   name: status,
  //                   count: 0,
  //                   percentage: 0,
  //                 };
  //               }
  //               summaryMap[status].percentage += item.percentage || 0;
  //               summaryMap[status].count += 1;
  //             });
  //             return Object.values(summaryMap);
  //           } else {
  //             // Old format: count items and use percentage from each item
  //             const summaryMap = {};
  //             items.forEach((item) => {
  //               const status = normalizeStatus(item.status);
  //               if (!summaryMap[status]) {
  //                 summaryMap[status] = {
  //                   name: status,
  //                   count: 0,
  //                   percentage: item.percentage ?? 0,
  //                 };
  //               }
  //               summaryMap[status].count += 1;
  //             });
  //             return Object.values(summaryMap);
  //           }
  //         };

  //         const summary = Array.isArray(res.data.summary)
  //           ? res.data.summary
  //           : buildStatusSummary(reversedData);

  //         setData(reversedData);
  //         const resolved = reversedData?.filter(
  //           (item) => item.status === "Responded"
  //         );
  //         const total = reversedData?.length;
  //         setDashboardData({
  //           total: total,
  //           pending: reversedData?.length - resolved?.length,
  //           closed: resolved?.length,
  //           summary,
  //         });
  //         setQueryUpdate(false);
  //       }
  //     } catch (error) {
  //       console.log("there is some error", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   if (queryUpdate) {
  //     getUserQueriesCall();
  //   }
  // }, [queryUpdate]);

  useEffect(() => {
    console.log("all query dashboard : 110");
    const getUserQueriesCall = async () => {
      setLoading(true);
      try {
        let res = await axios.get(`${AUTH_URL}api/allqueryadmin`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (res.data) {
          const apiPayload = Array.isArray(res.data?.data)
            ? res.data?.data
            : res.data?.data.queries || [];
          const reversedData = Array.isArray(apiPayload)
            ? [...apiPayload].reverse()
            : [];

          const normalizeStatus = (status) => {
            const s = (status || "pending").toLowerCase();
            if (s === "pending") return "Pending";
            if (s === "resolved" || s === "closed") return "Resolved";
            if (s === "rejected") return "Rejected";
            if (s === "responded") return "Responded";
            return "Other";
          };

          const buildStatusSummary = (items) => {
            // Check if items is the new format: array of {user_id, status, percentage}
            if (Array.isArray(items) && items.length > 0) {
              // New format: aggregate percentages by status
              const summaryMap = {};
              items.forEach((item) => {
                // const status = normalizeStatus(item.status);
                let status = item.llm_subcategory;
                if (status) {
                  status = status.replace(/\.+$/, "").trim();
                } else {
                  status = "Other";
                }
                if (!summaryMap[status]) {
                  summaryMap[status] = {
                    name: status,
                    count: 0,
                    // percentage: 0,
                  };
                }
                // summaryMap[status].percentage += item.percentage || 0;
                summaryMap[status].count += 1;
              });
              return Object.values(summaryMap);
            } else {
              // Old format: count items and use percentage from each item
              const summaryMap = {};
              items.forEach((item) => {
                const status = normalizeStatus(item.status);
                if (!summaryMap[status]) {
                  summaryMap[status] = {
                    name: status,
                    count: 0,
                    percentage: item.percentage ?? 0,
                  };
                }
                summaryMap[status].count += 1;
              });
              return Object.values(summaryMap);
            }
          };

          const summary = Array.isArray(res.data?.data.summary)
            ? res.data?.data.summary
            : buildStatusSummary(reversedData);

          setData(reversedData);
          const officer1 = reversedData?.filter(
            (item) =>
              item.llm_category.toLowerCase() ===
              "Employee/Pensioner of IA&AD".trim().toLowerCase(),
          );
          const officer2 = reversedData?.filter(
            (item) =>
              item.llm_category.toLowerCase() ===
              "Complaint pertaining to State Govt. Employees/ Pensioners if pending in PAGs/AGs offices"
                .trim()
                .toLowerCase(),
          );
          const total = reversedData?.length;
          setDashboardData({
            total: total,
            officer1: officer1?.length,
            officer2: officer2?.length,
            summary,
          });
          setQueryUpdate(false);
        }
      } catch (error) {
        console.log("there is some error", error);
      } finally {
        setLoading(false);
      }
    };
    if (queryUpdate) {
      getUserQueriesCall();
    }
  }, [queryUpdate]);

  useEffect(() => {
    console.log("overdue query dashboard");
    const getAdminQueriesCall = async () => {
      setLoading(true);
      try {
        let res = await axios.get(
          `${AUTH_URL}api/grievance_tat_exceeded_admin`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data) {
          const apiPayload = Array.isArray(res.data?.data)
            ? res.data?.data
            : res.data?.data?.queries || [];
          setOverdueData(apiPayload);
        }
      } catch (error) {
        console.log("there is some error", error);
      } finally {
        setLoading(false);
      }
    };
    if (queryUpdate) {
      getAdminQueriesCall();
    }
  }, [queryUpdate]);

  const handleSave = async () => {
    try {
      setSaveLoading(true);
      let res = await axios.put(
        `${AUTH_URL}api/grievance_response`,
        {
          query_id: selectedRow._id,
          officer_grievance_comments: selectedRow.officer_grievance_comments,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (res.status === 200) {
        setIsModalOpen(false);
        setQueryUpdate(true);
        Swal.fire({
          title: "Query Updated!",
          text: "You have successfully updated.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error in Update Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error?.response?.data?.error}` || "Error in Update Query API",
      });
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgOfficer})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="px-4 py-5 box-border w-full h-full"
    >
      <AdminUser
        dashboardData={dashboardData}
        data={data}
        overdueData={overdueData}
      />
    </div>
  );
};

export default AdminDashboard;
